import React from "react";

const PlaylistScaffoldNotice = (props) => {
    const type = props.type || "info";

    return (
        <div className={"alert alert-" + type} style={{marginBottom: "20px"}}>
            <strong>{props.title}</strong>
            <div style={{marginTop: "6px"}}>
                {props.children}
            </div>
        </div>
    );
};

export default PlaylistScaffoldNotice;
